import * as d3 from "d3";
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import cfg from '../config.json'
export function comparator(sel, data) {
    let trendEqual = data.config.iconTrendEqual;
    let trendUp = data.config.iconTrendUp;
    let trendDown = data.config.iconTrendDown;

  init();

  function init() {
    populate_empty_schoolfiles(cfg.maxCompare);
      d3.select(".btn-collapse-comparator").on("click", (e) => {if(d3.select('.comparator-wrapper').classed('collapsed')) {toggle_comparator('open');document.dispatchEvent(new CustomEvent("comparator-toggled-from-button",{detail:'open'}));} else {toggle_comparator('close');;document.dispatchEvent(new CustomEvent("comparator-toggled-from-button",{detail:'close'}));}});
      d3.select("#boutonComparateur").on('click',(e) => {document.dispatchEvent(new CustomEvent("comparator-toggled-from-button",{detail:'open'}));toggle_comparator('open')});
    // List/Map related events
    document.addEventListener("map-school-selected", (e) => {append_schoolfile(e.detail.school_code);});
    document.addEventListener("map-school-deselected", (e) => {remove_schoolfile(e.detail.school_code);});
    document.addEventListener("list-row-selected", (e) => {append_schoolfile(e.detail.school_code);});
    document.addEventListener("list-row-deselected", (e) => {remove_schoolfile(e.detail.school_code);});
    document.addEventListener("comparator-toggled-from-map", (e) => {toggle_comparator(e.detail);});

    // CAS SPÉCIAL : petit mobile WEB pas App :
      var hostURL = (window.location !== window.parent.location)
          ? document.referrer.split('/')[2]
          : window.location.host;
      if((hostURL === "www.journaldequebec.com") || (hostURL === "www.journaldemontreal.com")) {
          if (/(iPhone|iPod)/.test(navigator.userAgent)) {
              document.querySelector('.comparator-wrapper').classList.add('iphone');
          } else if (/(Android)/.test(navigator.userAgent)) {
              document.querySelector('.comparator-wrapper').classList.add('android');
          }
          const mainContainer = document.querySelector(".content-header");
          mainContainer.scrollIntoView({ behavior: "smooth",  inline: "nearest" });
      }

  }

  function populate_empty_schoolfiles(nbSchoolfiles) {
    for(let x=0;x<nbSchoolfiles;x++){
        let labelChiffre = (x+1)+'/'+nbSchoolfiles;
        let labelIcon = '<svg width="17" height="26" viewBox="0 0 17 26" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8.5" cy="14.5" r="1.5" fill="white"/><path d="M7.64286 23.3571V19.5889H9.35714V23.3571V24.3571H10.3571H15H16V23.3571V13.3437V12.8917L15.6607 12.5931L10.0618 7.66567V7.15317H11.1809C11.4289 7.71194 11.9842 8.10683 12.6368 8.10683H14.9536H15.9536V7.10683V2.96319V1.96319H14.9536H13.1358C12.8899 1.39939 12.332 1 11.6757 1H7.98H6.98V2V7.63209L1.33958 12.5928L1 12.8915V13.3437V23.3571V24.3571H2H6.64286H7.64286V23.3571ZM8.58009 14.4989C8.32823 14.5479 8.02874 14.3299 8.09506 13.9551C8.12974 13.7774 8.27739 13.6421 8.41527 13.6143C8.66713 13.5653 8.96661 13.7833 8.9003 14.1581C8.86562 14.3358 8.71797 14.4711 8.58009 14.4989Z" fill="#E9EBF3" stroke="white" stroke-width="2"/></svg>';

      const f = d3.select('#comparatorEmpty')
          .append("div")
          .attr("class", "schoolfile empty")
          .html(labelChiffre);
    }
  }

  function append_schoolfile(id) {
      const d = data.ecoles.find(all => all.school_code == id);
      document.dispatchEvent(new CustomEvent("comparator-school-added", { detail: d }));

      const f = sel
          .append("div")
          .datum(d)
          .attr("class", "schoolfile")
          .attr("id", d => "schoolfile-"+d.school_code)
          .html(rendered_schoolfile(d));

      update_comparator_btn();

      f
          .select("button")
          .on("click", function() {
            const d = d3.select(this).datum();
            remove_schoolfile(d.school_code);
          });
  }

  function rendered_schoolfile(d) {

      const returnProperIcon = (trend) => {
          let icon = trend === '112233' ? trendUp : trendEqual;
          icon = trend === "998855" ? trendDown : icon;
          return trend === "nd" ? "nd" : icon;
      }
      const pnum = function(str) {
          if (str == "nd") return str;
          return str.replace(/\./, ",");
      }
      const ppct = function(str) {
          if (str == "nd") return str;
          return str.replace(/\./, ",") + "%";
      }
      let trendrang = d.rang_2016_2022 > d.rang_2022 ? trendUp : trendEqual;
      trendrang = d.rang_2016_2022 < d.rang_2022 ? trendDown : trendrang;
      trendrang = d.rang_2016_2022 === "nd" ? "nd" : trendrang;

      const lang = d.langue == "français" ? "francophone" : "anglophone";

    return`
          <div class="comparator-col-header"> <!-- Here all the global infos about the school -->
            <button class="btn-delete"><span class="material-symbols-rounded make-smaller">close</span> Supprimer</button>
            <div class="schoolname">${d.nom}</div>
            <div class="schoolplace">${d.municipalite}</div>            
          </div>
          <div class="comparator-table">
            <table>
              <thead>
                <tr><th colspan="2" class="tx-left bg-yellow tx-blue tx-upp">${lang}<br>${d.secteur}</th></tr>
              </thead>
              <tbody class="not-visible-if-collapsed blue-line-bottom">
                <tr><td colspan="2" class="tx-darkblue tx-bold tx-bigger ">${d.étudiants}</td></tr>
                <tr><td colspan="2" class="tx-darkblue tx-bold tx-bigger">${ppct(d.ehdaa_2022)}</td></tr>
                </tbody>
              <tbody class="not-visible-if-collapsed blue-line-bottom">
                <tr><td class="bg-brightyellow tx-blue tx-bold">2022</td><td class="bg-brightyellow tx-blue tx-bold semi-opaque">TEND.</td></tr>
                <tr><td class="bg-lightblue tx-xbold tx-blue ">${pnum(d.cote_2022)} <small class="semi-opaque">/10</small></td><td class="bg-lightblue tx-bold tx-blue  semi-opaque">${returnProperIcon(d.cote_trend)}</td></tr>
                <tr><td class="bg-lightblue tx-xbold tx-blue">${d.rang} <small class="semi-opaque">/468</small></td><td class="bg-lightblue tx-bold tx-blue semi-opaque">${trendrang}</td></tr>
              </tbody>
              <tbody class="not-visible-if-collapsed blue-line-bottom odd-even">
                <tr><td>&nbsp;</td></tr>
                <!--<tr><td class="bg-lightblue tx-blue tx-bold">2022</td><td class="bg-light-blue tx-blue tx-bold semi-opaque">Tend.</td></tr>-->
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.lens_2022)}</td><td class=" tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.lens_trend)}</td></tr>
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.lsec_2022)}</td><td class=" tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.lsec_trend)}</td></tr>
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.scie_2022)}</td><td class=" tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.scie_trend)}</td></tr>
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.math_2022)}</td><td class=" tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.math_trend)}</td></tr>
                <tr><td class="tx-bold tx-darkblue">${pnum(d.hist_2022)}</td><td class="tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.hist_trend)}</td></tr>
              </tbody>
              <tbody class="not-visible-if-collapsed odd-even">
                <tr><td>&nbsp;</td></tr>
                <!--<tr><td class="bg-lightblue tx-blue tx-bold">2022</td><td class="bg-lightblue tx-blue tx-bold semi-opaque">Tend.</td></tr>-->
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.echec_2022)}</td><td class=" tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.echec_trend)}</td></tr>
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.sures_2022)}</td><td class=" tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.sures_trend)}</td></tr>
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.ecart_sexes_lens_2022)}</td><td class=" tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.ecart_sexes_math_trend)}</td></tr>
                <tr><td class=" tx-bold tx-darkblue">${pnum(d.ecart_sexes_math_2022)}</td><td class="tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.ecart_sexes_math_trend)}</td></tr>
                <tr><td class="tx-bold tx-darkblue">${pnum(d.prog_2022)}</td><td class="tx-bold tx-darkblue semi-opaque">${returnProperIcon(d.prog_trend)}</td></tr>
              </tbody>
            </table>
          </div>
    `;
  }

  function remove_schoolfile(id) {
    const d = data.ecoles.find(d => d.school_code == id);
    d3.select("#schoolfile-"+id).remove();
    document.dispatchEvent(new CustomEvent("comparator-school-removed", { detail: d }));
      update_comparator_btn();
  }



  function toggle_comparator(openOrClose) {
      if(openOrClose === 'close') {
          d3.select('.palmares-ecoles-outil-standalone').classed("noscroll", false);
          enablePageScroll();
          d3.select('.comparator-wrapper').classed("collapsed", true);
          d3.select('.info-bg').classed("hidden", true);
          d3.select('#boutonComparateur').classed("visible", true);
          d3.select('#boutonComparateur').classed("minified", true);
          setTimeout(() => {
              d3.select(".btn-collapse-comparator .plus-ou-moins").text("Afficher");
              d3.select('.btn-collapse-comparator .material-symbols-rounded').text("expand_less");
          }, 500);
      } else {
          d3.select('.palmares-ecoles-outil-standalone').classed("noscroll", true);
          disablePageScroll();
          d3.select('.comparator-wrapper').classed("collapsed", false);
          d3.select('#boutonComparateur').classed("visible", false);
          d3.select('#boutonComparateur').classed("minified", false);
          setTimeout(() => {
              d3.select(".btn-collapse-comparator .plus-ou-moins").text("Réduire");
              d3.select('.btn-collapse-comparator .material-symbols-rounded').text("expand_more");
          }, 500);
      }
  }

  function update_comparator_btn() {
      const ds = data.ecoles.filter(d => d.compared);
      d3.select("#nbCompared").text(ds.length);
      d3.select('#boutonComparateur').classed("ding",true);
      setTimeout( () => d3.select('#boutonComparateur').classed("ding",false),500);
  }

}
